import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/img/tele2visual.png'


const _hoisted_1 = { class: "tele2-banner" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "tele2-banner__inner" }
const _hoisted_4 = { class: "tele2-banner__left tele2-banner__item" }
const _hoisted_5 = { class: "tele2-banner__text" }
const _hoisted_6 = { class: "tele2-banner__title" }
const _hoisted_7 = { class: "tele2-banner__description" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("h1", _hoisted_6, _toDisplayString(_ctx.$t('banner.title')), 1),
            _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.$t('banner.subtitle')), 1)
          ])
        ]),
        _cache[0] || (_cache[0] = _createElementVNode("div", { class: "tele2-banner__right tele2-banner__item" }, [
          _createElementVNode("img", {
            class: "tele2-banner__img",
            src: _imports_0,
            alt: "banner"
          })
        ], -1))
      ])
    ])
  ]))
}